import type { ReactNode } from 'react';
import styles from './LoadingState.module.css';

export function Skeleton({ lines = 3 }: { lines?: number }): ReactNode {
  return (
    <div className={styles.skeleton} aria-hidden="true">
      <span className={styles.heading} />
      {Array.from({ length: lines }, (_, index) => (
        <span
          key={index}
          data-skeleton-line
          className={index === lines - 1 ? styles.shortLine : styles.line}
        />
      ))}
    </div>
  );
}

/** A quiet structural placeholder that still announces progress to assistive tech. */
export function LoadingState({ label = 'Loading' }: { label?: string }): ReactNode {
  return (
    <div
      className={styles.loading}
      role="status"
      aria-label={label}
      aria-busy="true"
    >
      <span className="visually-hidden">{label}</span>
      <Skeleton />
    </div>
  );
}
